import React, { useEffect } from "react";
import _ from "lodash";
import "../index.css";
import ImageAnalysis from "./ImageAnalysisContext/imageAnalysis";
import "./mi.css";
import { useSelector, useDispatch } from "react-redux";
import { miImageActions } from "../store/store";
import { v4 as uuid } from "uuid";
import { feedbackActions } from "../store/store";

export default function MiImageAnalysis(props) {
  const dispatch = useDispatch();
  const { auditDetails } = useSelector((state) => state.miAuditSearchStore);

  const generate_random_id = () => {
    return uuid().slice(0, 6);
  };

  const getImageUrl = (imageName) => {
    const url =
      "https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditImages/" +
      imageName +
      "?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D";
    return url;
  };
 useEffect(()=>{
  const func = () => {
    const res = auditDetails.map((img) => {
      console.log("29",JSON.parse(img.feedback_result));
    });
  };
  func();

  // checking for default answer
  let aggregateResult = auditDetails.map(r => JSON.parse(r.result)).flat()
  const filteredDefaultRes = aggregateResult.filter(r => r.width !== 1777)
  if (auditDetails.length > 0 && filteredDefaultRes.length === 0) {
    dispatch(feedbackActions.setSnackbarOpen(true))
    dispatch(feedbackActions.setSnackbarMessage('Analytical services not available at the moment, please try again later.'))
    dispatch(feedbackActions.setSnackbarMessageSeverity('warning'))
  }
 },[auditDetails])
 
  return (
    <div
      className="mi-scroll"
      style={{
        display: "flex",
        height: "calc(100vh-4.75rem)",
        overflowX: "auto",
        gap: "1em",
      }}
    >
      {auditDetails.map((img, i) => (
        <div>
          <ImageAnalysis
            key={i}
            imgNo={`${i + 1}`}
            uid={`${generate_random_id()}`}
            imageName={img["image_name"]}
            imagePath={getImageUrl(img.image_name)}
            thumbnailDetails={JSON.parse(img.feedback_result)}
            imageType ={img.type}
            imageAudit ={img.audit_id}
            resize={0.35}
          />
        </div>
      ))}
    </div>
  );
}
